import { createFileRoute } from '@tanstack/react-router';
import { legacyRedirect } from './-components';

// The old `journeys` URL for Layouts. The page lives at `/workspaces/:workspaceId/layouts`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/layouts/:layoutId/edit'),
});
